import { PolarAngleAxis, PolarGrid, Radar, RadarChart, ResponsiveContainer } from 'recharts';
import styles from '../../styles.module.scss';
import { CustomTick } from './CustomTick';

type Data = {
  label: string;
  value: number;
};

type Props = {
  chartTitle: string;
  data: Data[];
};

export const ScoreRadarChart: React.FC<Props> = ({ chartTitle, data }) => {
  return (
    <div className={styles.radarChartContainer}>
      <ResponsiveContainer width='100%' height={170}>
        <RadarChart data={data} margin={{ top: 20, right: 30, bottom: 20, left: 30 }}>
          <PolarGrid className={styles.radarGrid} />
          <PolarAngleAxis dataKey='label' tick={<CustomTick />} />
          <Radar
            dataKey='value'
            className={styles.radarChart}
            dot={{ className: styles.radarDot }}
          />
        </RadarChart>
      </ResponsiveContainer>
      <p className={styles.chartTitle}>{chartTitle}</p>
    </div>
  );
};
